module.exports = __webpack_public_path__ + "img/icon_ckpaid.274a742e.svg";